import * as io from "io-ts";
import { BlockImport, BlockModel } from ".";
import { withMessage } from "io-ts-types";
import t from "../../../../../i18n";

export const BlockImageKind = withMessage(io.strict({ kind: io.literal("IMAGE") }), () =>
  t("schema.block.kind"),
);

export const BlockImageData = io.type({ data: io.string });

export const BlockImageConfig = io.type({
  config: io.type({
    url: io.string,
  }),
});

export const BlockImageModel = io.intersection([
  BlockModel,
  BlockImageKind,
  BlockImageData,
  BlockImageConfig,
]);

export const BlockImageImport = io.intersection([
  BlockImport,
  BlockImageKind,
  BlockImageData,
  BlockImageConfig,
]);

export type BlockImageModelT = io.TypeOf<typeof BlockImageModel>;
export type BlockImageImportT = io.TypeOf<typeof BlockImageImport>;
